// extracted by mini-css-extract-plugin
module.exports = {"err":"Error_err__a_Kvb"};